<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ชื่อโปรไฟล์บริษัท:</label>
                <input
                  id="cucProfileName"
                  name="cucProfileName"
                  v-model="cucProfileName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อโปรไฟล์บริษัท"
                />
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ประเภทโปรไฟล์บริษัท:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'cucProfileTypeCode'"
                  :name="'cucProfileTypeCode'"
                  :select2-options="cucProfileTypeCodeOptions"
                  v-model="cucProfileTypeCode"
                  ref="cucProfileTypeCodeSelect2"
                  @selectChange="onCucProfileTypeCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              v-show="onShowCompanySelect2()"
              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"
            >
              <div class="form-group">
                <label class="label-required">บริษัท:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'cucCompanyCode'"
                  :name="'cucCompanyCode'"
                  :select2-options="cucCompanyCodeOptions"
                  v-model="cucCompanyCode"
                  ref="cucCompanyCodeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div
              v-show="ShowAgentMappingSelect2"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
            >
              <div class="form-group">
                <label class="label-required">ตัวแทนจำหน่าย: 
                      </label> 
                      <span  v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'" >
                      <input type="checkbox"  @change="SelectAllAgent($event)"
                      name="cucIsAllAgent" id="cucIsAllAgent" /> เลือกทั้งหมด</span>
                <!-- <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'cucAgenCodeMapping'"
                  :name="'cucAgenCodeMapping'"
                  :select2-options="cucAgenCodeMappingOptions"
                  v-model="cucAgenCodeMapping"
                  ref="cucAgenCodeSelect2"
                  multiple
                ></select2>
                <span class="form-text"></span> -->
                <treeselect
                  :id="'cucAgenCodeMapping'"
                  :name="'cucAgenCodeMapping'"
                  v-model="cucAgenCodeMapping"
                  :multiple="true"
                  :options="cucAgenCodeMappingOptions"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือก"
                  required
                />
                <span class="form-text"></span>
              </div>
            </div>

            <div
              v-show="ShowPhaseSelect2"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
            >
              <div class="form-group">
                <label class="label-required">Phase:</label>
                <!-- <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'cucPhases'"
                  :name="'cucPhases'"
                  :select2-options="cucPhaseOptions"
                  v-model="cucPhases"
                  ref="cucPhasesSelect2"
                  multiple
                ></select2> -->
                <treeselect
                  :id="'cucPhases'"
                  :name="'cucPhases'"
                  v-model="cucPhases"
                  :multiple="true"
                  :options="cucPhaseOptions"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือก Phase"
                  required
                />
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group">
                <label class="label-required">บทบาท:</label>
              </div>
            </div>

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_BR-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_BR'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูลสมาชิก</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brMASTER_USER"
                          name="MASTER_USER"
                          value="MASTER_USER"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('MASTER_USER')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ใบงานตรวจสอบ STOCK</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brBR_MANAGE_AUDIT_STOCK"
                          name="BR_MANAGE_AUDIT_STOCK"
                          value="BR_MANAGE_AUDIT_STOCK"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('BR_MANAGE_AUDIT_STOCK')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">แสดงผล (Dashboard รายงาน STOCK ระบบเบียร์สด)*มองเห็นทุกตัวแทนจำหน่าย</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brBR_DASHBOARD_AUDIT_STOCK"
                          name="BR_DASHBOARD_AUDIT_STOCK"
                          value="BR_DASHBOARD_AUDIT_STOCK"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('BR_DASHBOARD_AUDIT_STOCK')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">รับทรัพย์สินใหม่</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_IMPORT_NEW_ASSETS"
                          name="JOB_TYPE_RETRIEVE_NEW_ITEM"
                          value="JOB_ADMIN_IMPORT_NEW_ASSETS"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_IMPORT_NEW_ASSETS"
                          name="JOB_TYPE_RETRIEVE_NEW_ITEM"
                          value="JOB_IMPORT_NEW_ASSETS"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_RETRIEVE_NEW_ITEM')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ผลิตเบียร์สด</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_PRODUCE"
                          name="JOB_TYPE_PRODUCE"
                          value="JOB_ADMIN_PRODUCE"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_PRODUCE"
                          name="JOB_TYPE_PRODUCE"
                          value="JOB_PRODUCE"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_PRODUCE')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ทำลายทรัพย์สิน</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_DESTROY"
                          name="JOB_TYPE_DESTROY"
                          value="JOB_ADMIN_DESTROY"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_DESTROY"
                          name="JOB_TYPE_DESTROY"
                          value="JOB_DESTROY"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_DESTROY')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">อนุมัติทำลายทรัพย์สิน</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_APPROVER_DESTROY"
                          name="JOB_APPROVER_DESTROY"
                          value="JOB_APPROVER_DESTROY"
                        />
                        <span></span>
                        ผู้อนุมัติ
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_APPROVER_DESTROY')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ส่งสินค้าไปยังตัวแทน ฯ</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_TRANSFER_TO_AGENT"
                          name="JOB_TYPE_TRANSFER_TO_AGENT"
                          value="JOB_ADMIN_TRANSFER_TO_AGENT"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_TRANSFER_TO_AGENT"
                          name="JOB_TYPE_TRANSFER_TO_AGENT"
                          value="JOB_TRANSFER_TO_AGENT"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_TRANSFER_TO_AGENT')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">รับสินค้า/ทรัพย์สิน</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_RETRIEVE_ITEM"
                          name="JOB_TYPE_RETRIEVE_ITEM"
                          value="JOB_RETRIEVE_ITEM"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_RETRIEVE_ITEM')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ส่งซ่อมภายในคลัง</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_REPAIR"
                          name="JOB_TYPE_REPAIR"
                          value="JOB_ADMIN_REPAIR"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_REPAIR"
                          name="JOB_TYPE_REPAIR"
                          value="JOB_REPAIR"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_REPAIR')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ส่งซ่อมซัพพลายเออร์</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_REPAIR_SUPPLIER"
                          name="JOB_TYPE_REPAIR_SUPPLIER"
                          value="JOB_ADMIN_REPAIR_SUPPLIER"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_REPAIR_SUPPLIER"
                          name="JOB_TYPE_REPAIR_SUPPLIER"
                          value="JOB_REPAIR_SUPPLIER"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_REPAIR_SUPPLIER')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">รับคืนจากซัพพลายเออร์</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_RETURN_SUPPLIER"
                          name="JOB_TYPE_RETURN_SUPPLIER"
                          value="JOB_ADMIN_RETURN_SUPPLIER"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_RETURN_SUPPLIER"
                          name="JOB_TYPE_RETURN_SUPPLIER"
                          value="JOB_RETURN_SUPPLIER"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_RETURN_SUPPLIER')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">แลกเปลี่ยนสินค้า</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_EXCHANGE"
                          name="JOB_TYPE_EXCHANGE"
                          value="JOB_ADMIN_EXCHANGE"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_EXCHANGE"
                          name="JOB_TYPE_EXCHANGE"
                          value="JOB_EXCHANGE"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_EXCHANGE')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">เบิก/ยืม</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_BORROW"
                          name="JOB_TYPE_BORROW"
                          value="JOB_ADMIN_BORROW"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_BORROW"
                          name="JOB_TYPE_BORROW"
                          value="JOB_BORROW"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_BORROW')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">เบิก/ยืม (คลัง)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_BORROW_PLANT"
                          name="JOB_TYPE_BORROW_PLANT"
                          value="JOB_ADMIN_BORROW_PLANT"
                        />
                        <span></span>
                        แอดมิน
                      </label>

                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_BORROW_PLANT')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">เบิก/ยืม (จัดการใบงาน)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_BORROW_OPENJOB"
                          name="JOB_TYPE_BORROW_OPENJOB"
                          value="JOB_ADMIN_BORROW_OPENJOB"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_BORROW_OPENJOB')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox"
                  >รับคืนสินค้า/ทรัพย์สินจากลูกค้า</label
                >
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_RETURN"
                          name="JOB_TYPE_RETURN_ADHOC"
                          value="JOB_ADMIN_RETURN"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_RETURN"
                          name="JOB_TYPE_RETURN_ADHOC"
                          value="JOB_RETURN"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_RETURN_ADHOC')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ตรวจสอบใบ Hold</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_HOLD_CHECKER"
                          name="JOB_TYPE_HOLD_CHECKER"
                          value="JOB_ADMIN_HOLD_CHECKER"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_HOLD_CHECKER')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ใบงานตัดยอดคงค้าง</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brJOB_ADMIN_WRITE_OFF_STOCK_PLANT"
                          name="JOB_TYPE_WRITE_OFF_STOCK_PLANT"
                          value="JOB_ADMIN_WRITE_OFF_STOCK_PLANT"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_WRITE_OFF_STOCK_PLANT')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ข้อมูลรายงาน</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brBR_REPORT"
                          name="BR_REPORT"
                          value="BR_REPORT"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('BR_REPORT')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">Beer Claim (เจ้าหน้าที่ทรัพย์สินเบียร์สด BRT)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brDB_OFFICER_BEER_CLAIM"
                          name="DB_OFFICER_BEER_CLAIM"
                          value="DB_OFFICER_BEER_CLAIM"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('DB_OFFICER_BEER_CLAIM')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">Beer Claim (ผจก.ฝ่ายผลิต)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="brADMIN_PLANT_BEER_CLAIM"
                          name="ADMIN_PLANT_BEER_CLAIM"
                          value="ADMIN_PLANT_BEER_CLAIM"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('ADMIN_PLANT_BEER_CLAIM')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_BR-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_AGENT-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'"
            >
            <div class="form-group">
                <label class="kt-checkbox">ใบงานตรวจสอบ STOCK</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aMANAGE_AUDIT_STOCK"
                          name="MANAGE_AUDIT_STOCK"
                          value="MANAGE_AUDIT_STOCK"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('MANAGE_AUDIT_STOCK')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูลร้านค้า</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aMANAGE_SHOP"
                          name="MANAGE_SHOP"
                          value="MANAGE_SHOP"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('MANAGE_SHOP')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox"
                  >จัดการข้อมูลสมาชิกตัวแทน/ตัวแทนจำหน่ายย่อย</label
                >
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aMANAGE_SUB_AGENT_USER"
                          name="MANAGE_SUB_AGENT_USER"
                          value="MANAGE_SUB_AGENT_USER"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_SUB_AGENT_USER')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">รับสินค้า/ทรัพย์สิน</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_RETRIEVE_ITEM"
                          name="JOB_TYPE_RETRIEVE_ITEM"
                          value="JOB_RETRIEVE_ITEM"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_RETRIEVE_ITEM')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox"
                  >ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า</label
                >
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_ADMIN_TRANSFER_TO_SHOP"
                          name="JOB_TYPE_TRANSFER_TO_SHOP"
                          value="JOB_ADMIN_TRANSFER_TO_SHOP"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_TRANSFER_TO_SHOP"
                          name="JOB_TYPE_TRANSFER_TO_SHOP"
                          value="JOB_TRANSFER_TO_SHOP"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_TRANSFER_TO_SHOP')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">หยิบสินค้าขึ้นรถ (เร่ขาย)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_ADMIN_PICKUP"
                          name="JOB_TYPE_PICKUP"
                          value="JOB_ADMIN_PICKUP"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_PICKUP"
                          name="JOB_TYPE_PICKUP"
                          value="JOB_PICKUP"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_PICKUP')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">แลกเปลี่ยนสินค้า</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_ADMIN_EXCHANGE"
                          name="JOB_TYPE_EXCHANGE"
                          value="JOB_ADMIN_EXCHANGE"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_EXCHANGE"
                          name="JOB_TYPE_EXCHANGE"
                          value="JOB_EXCHANGE"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_EXCHANGE')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">เบิก/ยืม</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_ADMIN_BORROW"
                          name="JOB_TYPE_BORROW"
                          value="JOB_ADMIN_BORROW"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_BORROW"
                          name="JOB_TYPE_BORROW"
                          value="JOB_BORROW"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_BORROW')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox"
                  >รับคืนสินค้า/ทรัพย์สินจากลูกค้า</label
                >
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_ADMIN_RETURN"
                          name="JOB_TYPE_RETURN_ADHOC"
                          value="JOB_ADMIN_RETURN"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_RETURN"
                          name="JOB_TYPE_RETURN_ADHOC"
                          value="JOB_RETURN"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_RETURN_ADHOC')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ใบงานตัดยอดคงค้าง</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_ADMIN_WRITE_OFF_STOCK_AGENT"
                          name="JOB_TYPE_WRITE_OFF_STOCK"
                          value="JOB_ADMIN_WRITE_OFF_STOCK_AGENT"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_WRITE_OFF_STOCK')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ข้อมูลรายงาน</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aAGENT_REPORT"
                          name="AGENT_REPORT"
                          value="AGENT_REPORT"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('AGENT_REPORT')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox"
                  >ข้อมูลการเรียนรู้ (E-Learning)</label
                >
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aAGENT_E-Learning"
                          name="AGENT_E-Learning"
                          value="AGENT_E-Learning"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('AGENT_E-Learning')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ข้อมูล KPI</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_AGENT_KPI"
                          name="JOB_AGENT_KPI"
                          value="JOB_AGENT_KPI"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_AGENT_KPI')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox"
                  >งานล้างเครื่องเบียร์สด (จัดการใบงาน)</label
                >
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_ADMIN_PM"
                          name="JOB_ADMIN_PM"
                          value="JOB_ADMIN_PM"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_ADMIN_PM')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">งานล้างเครื่องเบียร์สด  (ตัวแทน)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aAGENT_ADMIN_PM"
                          name="AGENT_ADMIN_PM"
                          value="AGENT_ADMIN_PM"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('AGENT_ADMIN_PM')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
             <div class="form-group" >
                <label class="kt-checkbox">งานล้างเครื่องเบียร์สด (ตัวแทนจำหน่ายย่อย)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aSUB_AGENT_ADMIN_PM"
                          name="SUB_AGENT_ADMIN_PM"
                          value="SUB_AGENT_ADMIN_PM"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('SUB_AGENT_ADMIN_PM')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>  
              <div class="form-group">
                <label class="kt-checkbox"
                  >สร้างร้านค้าใหม่ (จัดการใบงาน)</label
                >
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aADMIN_NEW_SHOP"
                          name="JOB_TYPE_NEW_SHOP"
                          value="ADMIN_NEW_SHOP"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_NEW_SHOP')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="form-group">
                <label class="kt-checkbox">Beer Claim (จัดการใบงาน)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_ADMIN_BEER_CLAIM"
                          name="JOB_TYPE_BEER_CLAIM"
                          value="JOB_ADMIN_BEER_CLAIM"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_BEER_CLAIM')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="form-group">
                <label class="kt-checkbox">Beer Claim</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aAGENT_ADMIN_BEER_CLAIM"
                          name="AGENT_ADMIN_BEER_CLAIM"
                          value="AGENT_ADMIN_BEER_CLAIM"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('AGENT_ADMIN_BEER_CLAIM')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล BARCODE (ตัวแทน)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aMANAGE_BARCODE_AGENT"
                          name="MANAGE_BARCODE_AGENT"
                          value="MANAGE_BARCODE_AGENT"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('MANAGE_BARCODE_AGENT')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox"
                  >งานตรวจสอบคุณภาพเบียร์สด (จัดการใบงาน)</label
                >
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aJOB_ADMIN_QI"
                          name="JOB_TYPE_QI"
                          value="JOB_ADMIN_QI"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_QI')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_AGENT-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_SUB_AGENT-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_SUB_AGENT'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูลร้านค้าตัวแทนจำหน่ายย่อย</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="sMANAGE_SHOP_SUB_AGENT"
                          name="MANAGE_SHOP_SUB_AGENT"
                          value="MANAGE_SHOP_SUB_AGENT"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_SHOP_SUB_AGENT')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">รับสินค้า/ทรัพย์สิน</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="sJOB_RETRIEVE_ITEM"
                          name="JOB_TYPE_RETRIEVE_ITEM"
                          value="JOB_RETRIEVE_ITEM"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_RETRIEVE_ITEM')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox"
                  >ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="sJOB_ADMIN_TRANSFER_TO_SHOP"
                          name="JOB_TYPE_TRANSFER_TO_SHOP"
                          value="JOB_ADMIN_TRANSFER_TO_SHOP"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="sJOB_TRANSFER_TO_SHOP"
                          name="JOB_TYPE_TRANSFER_TO_SHOP"
                          value="JOB_TRANSFER_TO_SHOP"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_TRANSFER_TO_SHOP')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox"
                  >รับคืนสินค้า/ทรัพย์สินจากลูกค้า</label
                >
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="sJOB_ADMIN_RETURN"
                          name="JOB_TYPE_RETURN_ADHOC"
                          value="JOB_ADMIN_RETURN"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="sJOB_RETURN"
                          name="JOB_TYPE_RETURN_ADHOC"
                          value="JOB_RETURN"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('JOB_TYPE_RETURN_ADHOC')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ข้อมูลรายงาน (ตัวแทนจำหน่ายย่อย)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="sSUB_AGENT_REPORT"
                          name="SUB_AGENT_REPORT"
                          value="SUB_AGENT_REPORT"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('SUB_AGENT_REPORT')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล BARCODE (ตัวแทนจำหน่ายย่อย)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aMANAGE_BARCODE_SUB_AGENT"
                          name="MANAGE_BARCODE_SUB_AGENT"
                          value="MANAGE_BARCODE_SUB_AGENT"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('MANAGE_BARCODE_SUB_AGENT')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group"  >
                <label class="kt-checkbox">งานล้างเครื่องเบียร์สด (ตัวแทนจำหน่ายย่อย)</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="aSUB_AGENT_ADMIN_PM"
                          name="SUB_AGENT_ADMIN_PM"
                          value="SUB_AGENT_ADMIN_PM"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('SUB_AGENT_ADMIN_PM')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="kt-checkbox">ใบงานตัดยอดคงค้าง</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="sJOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT"
                          name="JOB_TYPE_WRITE_OFF_STOCK_SUB_AGENT"
                          value="JOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioVal('JOB_TYPE_WRITE_OFF_STOCK_SUB_AGENT')"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_SUB_AGENT-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_PM-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="pmADMIN_PM"
                          name="MANAGE_COMPANYPROFILE_PM"
                          value="ADMIN_PM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="pmUSER_PM"
                          name="MANAGE_COMPANYPROFILE_PM"
                          value="USER_PM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        พนักงาน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="pmCOOL_SERVICE_PM"
                          name="MANAGE_COMPANYPROFILE_PM"
                          value="COOL_SERVICE_PM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        Cooling
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_COMPANYPROFILE_PM')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first"  
            v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM' && ShowRoleOptionUserAndCoolService ">
            <h3 class="kt-section__title">รายการเข้าทำ PM &nbsp;<a href="#" @click.prevent="showPmExampleModal"><u><i class="fa fa-info-circle"></i> กดเพื่อดูตัวอย่างการตั้งค่า</u></a> :</h3>

            <!-- begin: PM Example Modal -->
            <div
              class="modal fade"
              id="pmExampleModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="pmExampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="pmExampleModalLabel">
                      ตัวอย่างการตั้งค่า
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img
                      src="/images/company-profile-pm-example.jpg"
                      alt="ตัวอย่างการตั้งค่า"
                      class="img-fluid"
                      style="max-width: 100%;"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- end: PM Example Modal -->
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                    style="min-width: 1440px;"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="80px">ลำดับ</th> 
                        <th class="text-center" width="350px">ตัวแทนจำหน่าย</th>
                        <th class="text-center" >ตัวแทนจำหน่ายย่อย</th> 
                        <th class="text-center" width="350px">บทบาท</th> 
                        <th class="text-center" width="5%">คำสั่ง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="odcitems == null || odcitems.length == 0">
                        <td colspan="9" class="text-muted text-center">
                          คลิก + เพื่อเพิ่มรายการใหม่
                        </td>
                      </tr>
                      <template v-for="(item, i) in odcitems">
                        <order-item-row
                          ref="jobItems"
                          :key="item.ucode" 
                          :rowIndex="i"
                          :item="item"
                          @removeItem="onRemoveItemClick"
                        ></order-item-row>
                      </template>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="9">
                          <button
                            type="button"
                            class="btn btn-sm btn-brand"
                            @click.prevent="onAddItemClick"
                          >
                            <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>

            <!-- End : บทบาท COMPANY_PROFILE_TYPE_PM-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_BEER_CLAIM-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_BEER_CLAIM'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="ADMIN_BEER_CLAIM"
                          name="MANAGE_COMPANYPROFILE_BEER_CLAIM"
                          value="ADMIN_BEER_CLAIM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="MANAGER_BEER_CLAIM"
                          name="MANAGE_COMPANYPROFILE_BEER_CLAIM"
                          value="MANAGER_BEER_CLAIM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ผู้จัดการ
                      </label>
                      <!-- <label class="kt-radio">
                        <input
                          type="radio"
                          id="USER_BEER_CLAIM"
                          name="MANAGE_COMPANYPROFILE_BEER_CLAIM"
                          value="USER_BEER_CLAIM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        พนักงาน
                      </label> -->
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="QI_OFFICER_BEER_CLAIM"
                          name="MANAGE_COMPANYPROFILE_BEER_CLAIM"
                          value="QI_OFFICER_BEER_CLAIM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        เจ้าหน้าที่ทีม QC
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="PLANT_ACCOUNTANT_BEER_CLAIM"
                          name="MANAGE_COMPANYPROFILE_BEER_CLAIM"
                          value="PLANT_ACCOUNTANT_BEER_CLAIM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        เจ้าหน้าที่บัญชีคลังสินค้า
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="LAB_BEER_CLAIM"
                          name="MANAGE_COMPANYPROFILE_BEER_CLAIM"
                          value="LAB_BEER_CLAIM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        LAB
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="ADMIN_PLANT_BEER_CLAIM"
                          name="MANAGE_COMPANYPROFILE_BEER_CLAIM"
                          value="ADMIN_PLANT_BEER_CLAIM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ผู้จัดการฝ่ายผลิต
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="DB_OFFICER_BEER_CLAIM"
                          name="MANAGE_COMPANYPROFILE_BEER_CLAIM"
                          value="DB_OFFICER_BEER_CLAIM"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        เจ้าหน้าที่ทรัพย์สินเบียร์สด
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_COMPANYPROFILE_BEER_CLAIM')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_BEER_CLAIM-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_QI-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="ADMIN_QI"
                          name="MANAGE_COMPANYPROFILE_QI"
                          value="ADMIN_QI"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="MANAGER_QI"
                          name="MANAGE_COMPANYPROFILE_QI"
                          value="MANAGER_QI"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ผู้จัดการ
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="USER_QI"
                          name="MANAGE_COMPANYPROFILE_QI"
                          value="USER_QI"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        พนักงาน
                      </label>

                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_COMPANYPROFILE_QI')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="kt-checkbox">ข้อมูล Dashboard</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="USER_DASHBOARD"
                          name="USER_DASHBOARD"
                          value="USER_DASHBOARD"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="onClearRadioValQI()"
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_QI-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_MKT-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_MKT'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="ADMIN_MKT"
                          name="MANAGE_COMPANYPROFILE_MKT"
                          value="ADMIN_MKT"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="MANAGER_MKT"
                          name="MANAGE_COMPANYPROFILE_MKT"
                          value="MANAGER_MKT"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ผู้จัดการ
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="USER_MKT"
                          name="MANAGE_COMPANYPROFILE_MKT"
                          value="USER_MKT"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        พนักงาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_COMPANYPROFILE_MKT')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_MKT-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_5S-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_5S'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="ADMIN_5S"
                          name="MANAGE_COMPANYPROFILE_5S"
                          value="ADMIN_5S"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <!-- <label class="kt-radio">
                        <input
                          type="radio"
                          id="USER_5S"
                          name="MANAGE_COMPANYPROFILE_5S"
                          value="USER_5S"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        พนักงาน
                      </label> -->
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="ADVISOR_5S"
                          Advisor
                          name="MANAGE_COMPANYPROFILE_5S"
                          value="ADVISOR_5S"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ที่ปรึกษา
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="TEAM_5S"
                          Advisor
                          name="MANAGE_COMPANYPROFILE_5S"
                          value="TEAM_5S"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ทีมงาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_COMPANYPROFILE_5S')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_5S-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="
                cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING'
              "
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="ADMIN_EQUIPMENT_LEASING"
                          name="MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING"
                          value="ADMIN_EQUIPMENT_LEASING"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <!-- <label class="kt-radio">
                        <input
                          type="radio"
                          id="MANAGER_EQUIPMENT_LEASING"
                          name="MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING"
                          value="MANAGER_EQUIPMENT_LEASING"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ผู้จัดการ
                      </label> -->
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="USER_EQUIPMENT_LEASING"
                          name="MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING"
                          value="USER_EQUIPMENT_LEASING"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        พนักงาน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal(
                            'MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING'
                          )
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_QIMAINTAIN-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_QIMAINTAIN'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="OFFICER_QIMAINTAIN"
                          name="MANAGE_COMPANYPROFILE_QIMAINTAIN"
                          value="OFFICER_QIMAINTAIN"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ธุรการช่างซ่อมบำรุง
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="OFFICER_PLANT_QIMAINTAIN"
                          name="MANAGE_COMPANYPROFILE_QIMAINTAIN"
                          value="OFFICER_PLANT_QIMAINTAIN"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ธุรการคลังเบียร์สด
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="QI_QIMAINTAIN"
                          name="MANAGE_COMPANYPROFILE_QIMAINTAIN"
                          value="QI_QIMAINTAIN"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        ช่างซ่อมบำรุง
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="CHECKER_QIMAINTAIN"
                          name="MANAGE_COMPANYPROFILE_QIMAINTAIN"
                          value="CHECKER_QIMAINTAIN"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        Checker
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="LEAD_QIMAINTAIN"
                          name="MANAGE_COMPANYPROFILE_QIMAINTAIN"
                          value="LEAD_QIMAINTAIN"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        หัวหน้าช่างซ่อมบำรุง
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_COMPANYPROFILE_QIMAINTAIN')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_QIMAINTAIN-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_BUDGET-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_BUDGET'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล Budget Approval</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="BUDGET_PLAN_USER"
                          name="MANAGE_COMPANYPROFILE_BUDGET"
                          value="BUDGET_PLAN_USER"
                          @change="OnBudgetPlanRoleChange($event)"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="BUDGET_PLAN_REVIEWER"
                          name="MANAGE_COMPANYPROFILE_BUDGET"
                          value="BUDGET_PLAN_REVIEWER"
                          @change="OnBudgetPlanRoleChange($event)"
                        />
                        <span></span>
                        ผู้ตรวจสอบ
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="BUDGET_PLAN_MANAGER"
                          name="MANAGE_COMPANYPROFILE_BUDGET"
                          value="BUDGET_PLAN_MANAGER"
                          @change="OnBudgetPlanRoleChange($event)"
                        />
                        <span></span>
                        ผู้จัดการฝ่าย
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_COMPANYPROFILE_BUDGET')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_BUDGET-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_AGENT_SCORE-->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT_SCORE'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูลคะแนนตัวแทนจำหน่าย</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="AGENT_SCORE_ADMIN"
                          name="MANAGE_COMPANYPROFILE_AGENT_SCORE"
                          value="AGENT_SCORE_ADMIN"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_COMPANYPROFILE_AGENT_SCORE')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_AGENT_SCORE-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_SCVD (CR-StockCoverDays) -->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_SCVD'"
            >
              <div class="form-group">
                <label class="kt-checkbox">จัดการข้อมูล Stock Cover Days</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="SCVD_ADMIN"
                          name="MANAGE_COMPANYPROFILE_SCVD"
                          value="SCVD_ADMIN"
                          @change="scvdRole = 'SCVD_ADMIN'"
                        />
                        <span></span>
                        แอดมิน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="SCVD_VIEWER"
                          name="MANAGE_COMPANYPROFILE_SCVD"
                          value="SCVD_VIEWER"
                          @change="scvdRole = 'SCVD_VIEWER'"
                        />
                        <span></span>
                        ผู้ใช้งาน
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="SCVD_TEAM_EDIT"
                          name="MANAGE_COMPANYPROFILE_SCVD"
                          value="SCVD_TEAM_EDIT"
                          @change="scvdRole = 'SCVD_TEAM_EDIT'"
                        />
                        <span></span>
                        ทีมสร้าง/แก้ไขข้อมูลตามเป้าหมาย
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal('MANAGE_COMPANYPROFILE_SCVD')
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_SCVD-->

            <!-- Begin : บทบาท COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK (CR-FormSummaryStock) -->
            <!-- id ของ radio ต้องเท่ากับค่าบทบาทเป๊ะ ๆ เพราะหน้าแก้ไข restore ค่าเดิมด้วย
                 $("#" + formatId + role) และ formatId ของ profile type นี้เป็นค่าว่าง -->
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK'"
            >
              <div class="form-group">
                <!-- FS-127 (19/10/2026) — หัวข้อบทบาทตั้งตามชื่อเอกสารสรุป (อนาคต module นี้มีเอกสารสรุปหลายชุด) -->
                <label class="kt-checkbox" data-test="fss-profile-role-title">เอกสารสรุปสินค้าคงค้าง</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline">
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="FORM_SUMMARY_STOCK_ADMIN"
                          name="MANAGE_COMPANYPROFILE_FORM_SUMMARY_STOCK"
                          value="FORM_SUMMARY_STOCK_ADMIN"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        แอดมินทีมเบียร์สด
                      </label>
                      <label class="kt-radio">
                        <input
                          type="radio"
                          id="FORM_SUMMARY_STOCK_AGENT"
                          name="MANAGE_COMPANYPROFILE_FORM_SUMMARY_STOCK"
                          value="FORM_SUMMARY_STOCK_AGENT"
                          @change="OnRadioBtnChange($event)"
                        />
                        <span></span>
                        แอดมิน (ตัวแทนจำหน่าย)
                      </label>
                      <a
                        href="#"
                        title="reset"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        @click.prevent="
                          onClearRadioVal(
                            'MANAGE_COMPANYPROFILE_FORM_SUMMARY_STOCK'
                          )
                        "
                      >
                        <i class="fa fa-times-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End : บทบาท COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK-->

            <!-- Begin : เลือกแผนก COMPANY_PROFILE_TYPE_BUDGET-->
            <div
              v-show="ShowBudgetOrgSelect2"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
            >
              <div class="form-group">
                <label class="label-required">แผนก:</label>
                <treeselect
                  :id="'cucBudgetOrgIds'"
                  :name="'cucBudgetOrgIds'"
                  v-model="cucBudgetOrgIds"
                  :multiple="true"
                  :options="cucBudgetOrgOptions"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือกแผนก"
                  required
                />
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End : เลือกแผนก COMPANY_PROFILE_TYPE_BUDGET-->
          </div>

         

          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="cucInActiveStatus"
                      id="cucInActiveStatus"
                      v-model="cucInActiveStatus"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-show="ShowEmailAlertPM == true">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group">
                <label>Email Alert PM:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="EmailAlertPM"
                      id="EmailAlertPM"
                      v-model="EmailAlertPM"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div> 
          <!--  -->
          <div class="row"   v-show="cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group">
                <label>แจ้งเตือนคงค้างเกินกำหนดเวลา (Website): </label>
                
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="EmailWebAlertOverdue"
                      id="EmailWebAlertOverdue"
                      v-model="EmailWebAlertOverdue"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="kt-portlet__foot">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล 
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

// import the component
import Treeselect from "@riophae/vue-treeselect";
import orderItemRow from "./ItemRow";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";


export default {
  components: {
    select2,
    Treeselect,
    orderItemRow
  },
  data: function() {
    var self = this;

    return {
      cucProfileName: null,
      cucProfileTypeCode: null,
      cucPlantCode: null,
      cucAgentCode: null,
      cucShopCode: null,
      cucRoles: [],
      cucInActiveStatus: true,
      cucCompanyCode: null,
      scvdRole: null, // CR-StockCoverDays: SCVD role ที่เลือก (radio ไม่มี v-model) — ใช้คุมการแสดง/ผูกช่อง "บริษัท" (เฉพาะ Viewer ผูกคลัง)
      cucAgenCodeMapping: [],
      ShowAgentMappingSelect2: false,
      cucPhases: [],
      ShowPhaseSelect2: false,
      EmailAlertPM: false,
      EmailWebAlertOverdue: false,
      ShowEmailAlertPM: false,

      OdcAgentOptions: [],
      odcitems: [],
      ShowRoleOptionUserAndCoolService : false,

      // Budget Plan
      cucBudgetOrgIds: [],
      cucBudgetOrgOptions: [],
      ShowBudgetOrgSelect2: false,  
      // Configurations
      cucProfileTypeCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "COMPANY_PROFILE_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cucCompanyCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        //minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/CompanyProfile/Select2Company",
          data: function(params) {
            var query = {
              profileTypeCode: self.cucProfileTypeCode,
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cucAgenCodeMappingOptions: [],
      // cucAgenCodeMappingOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   minimumResultsForSearch: -1,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: [],
      //         province_id: [],
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      cucPhaseOptions: [],
      // cucPhaseOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือก Phase",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Phase",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    showPmExampleModal() {
      $("#pmExampleModal").modal("show");
    },
    onAddItemClick(e) {

      var _ucode = Date.now().toString(36) + Math.random().toString(36) ;
      this.odcitems.push({
        ucode:_ucode,
        odcAgentCode: null,
        odcSubAgentCode: null,
        odcRouteAgentOption: null ,
        isSubAgentEditable : true ,
        isAgentEditable : true ,
        isDuplicated : false,
        isOptionRequired : true 
      });

      this.onValidateDuplicated();
    },
    onValidateDuplicated(e){ 
        var arrItems = JSON.parse(JSON.stringify(this.odcitems));
        
        $.each(this.odcitems, function( index, obj ) {  
          obj.isDuplicated = false ;
          $.each(arrItems, function( index2, obj2 ) {
            if(index!=index2 && obj.odcAgentCode == obj2.odcAgentCode && obj.odcSubAgentCode == obj2.odcSubAgentCode ){
                obj.isDuplicated = true ;
            }
          });  
        }); 
  
    },
    onRemoveItemClick(index, delItem) {  
      this.odcitems.splice(index, 1);
        for (let i = 0; i < this.odcitems.length; i++) { 
        }
      this.onValidateDuplicated();
    },
    formSubmit: function(e) { 
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      let self = this;
      let router = this.$router;
      self.cucRoles = [];

      var radioVal = $("input:radio:checked");
      if (radioVal.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกบทบาท", "error");
      } else {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
        });

        $(radioVal).each(function(i) {
          self.cucRoles.push($(this).val());
        });

        if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_BR") {
          self.cucPlantCode = self.cucCompanyCode;
        } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SCVD") {
          // CR-StockCoverDays: เฉพาะ "ผู้ใช้งาน" (SCVD_VIEWER) ผูกคลัง; แอดมิน/ทีม เห็นทุกคลัง → ไม่ผูก plant
          self.cucPlantCode =
            self.scvdRole == "SCVD_VIEWER" ? self.cucCompanyCode : null;
        } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT") {
          self.cucAgentCode = self.cucCompanyCode;
        } else if (
          self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT"
        ) {
          self.cucShopCode = self.cucCompanyCode;
        }

        if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") {
          var chk =
            self.cucRoles.includes("ADMIN_QI") ||
            self.cucRoles.includes("MANAGER_QI") ||
            self.cucRoles.includes("USER_QI");

          if (!chk) {
            Swal.fire(
              "เกิดข้อผิดพลาด",
              "กรุณาเลือกบทบาท จัดการข้อมูล",
              "error"
            );
            KTApp.unblockPage();
            return false;
          }
        }

        //EmailAlertPm
        var EmailAlertPM = false;
        if ((self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") && (self.cucRoles.includes("USER_QI") || self.cucRoles.includes("USER_MKT")) )
        {
          EmailAlertPM = self.EmailAlertPM;
        }

        axios
          .post("/Api/CompanyProfile", {
            ProfileName: self.cucProfileName,
            ProfileTypeCode: self.cucProfileTypeCode,
            PlantCode: self.cucPlantCode,
            AgentCode: self.cucAgentCode,
            ShopCode: self.cucShopCode,
            Roles: self.cucRoles,
            InActiveStatus: !self.cucInActiveStatus,
            AgentCodes: self.cucAgenCodeMapping,
            Phases: self.cucPhases,
            EmailAlertPM: EmailAlertPM,
            EmailWebAlertOverdue: self.EmailWebAlertOverdue,
            PMClaims: self.odcitems,
            BudgetOrgIds: self.cucBudgetOrgIds
          })
          .then(function(response) {
            if (response.data.status) {
              KTApp.unblockPage();
              Swal.fire("สำเร็จ", response.data.message, "success").then(
                function() {
                  router.go(-1), self.$parent.reloadDataTable(false);
                }
              );
            } else {
              //console.log(response);
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          })
          .catch(function(error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          })
          .then(function() {
            // always executed
            KTApp.unblockPage();
          });
      }
    },
    onClearRadioVal: function(name) {
      $("input[name=" + name + "]").prop("checked", false);

      this.ShowAgentMappingSelect2 = false;
      $("#cucAgenCodeMapping")
        .val("")
        .trigger("change");
      this.cucAgenCodeMapping = [];

      this.ShowPhaseSelect2 = false;
      $("#cucPhases")
        .val("")
        .trigger("change");
      this.cucPhases = [];

      // CR-StockCoverDays: เคลียร์ SCVD role ที่จำไว้ → ช่อง "บริษัท" กลับไปซ่อน
      if (name == "MANAGE_COMPANYPROFILE_SCVD") {
        this.scvdRole = null;
      }
    },
    onClearRadioValQI: function(e) {
      $("#USER_DASHBOARD").prop("checked", false);
    },
    OnRadioBtnChange: function(e) {
      var self = this;
      var val = e.target.value;

      this.odcitems = [];
      if(val=='USER_PM'){ // || val == 'COOL_SERVICE_PM'
        self.ShowRoleOptionUserAndCoolService = true; 
      }else{
        self.ShowRoleOptionUserAndCoolService = false;
      }

      //เครื่องเช่า
      if (
        self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING" &&
        (val.includes("MANAGER") || val.includes("USER"))
      ) {
        self.ShowPhaseSelect2 = true;
      } else {
        self.ShowPhaseSelect2 = false;
        $("#cucPhases")
          .val("")
          .trigger("change");
        self.cucPhases = [];
      }
 
      //อื่นๆ ที่ไม่ใช่เครื่องเช่า (ph2)
      if (
        self.cucProfileTypeCode != "COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING" &&
        ((self.cucProfileTypeCode != "COMPANY_PROFILE_TYPE_BEER_CLAIM" && val.includes("MANAGER")) ||
          val.includes("USER") ||
          val.includes("TEAM") ||
          val.includes("ADVISOR") ||
          val.includes("COOL_SERVICE_PM") || 
          val.includes("QI_OFFICER"))
      ) {
        self.ShowAgentMappingSelect2 = true; 
      } else {
        self.ShowAgentMappingSelect2 = false;
        $("#cucAgenCodeMapping")
          .val("")
          .trigger("change");

        this.cucAgenCodeMapping = [];
      }

      //cr-ตัวแทนย่อย
      if(self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_PM" && (val.includes("USER") )){ //|| val.includes("COOL_SERVICE_PM")
          self.ShowAgentMappingSelect2 = false;
        }

      //CR-FormSummaryStock: ชื่อบทบาทของ CR นี้ไม่มีคำที่บล็อก (ph2) ใช้ match (MANAGER/USER/TEAM/ADVISOR/...)
      //ช่อง "ตัวแทนจำหน่าย" จึงถูกปิดไปใน else ด้านบน ต้องเปิดเองเฉพาะ "แอดมิน (ตัวแทนจำหน่าย)"
      //เพราะขอบเขตข้อมูลของบทบาทนี้อ่านจาก AgentMapping ของโปรไฟล์ — ไม่ผูกตัวแทน = เห็นข้อมูล 0 รายการ
      //ส่วน "แอดมินทีมเบียร์สด" เห็นตัวแทนจำหน่ายทุกรายอยู่แล้ว จึงไม่ต้องผูก
      //(ซ่อนไว้ jQuery validate ข้าม required ให้เองผ่าน settings.ignore = ":hidden")
      if (
        self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK"
      ) {
        self.ShowAgentMappingSelect2 = val == "FORM_SUMMARY_STOCK_AGENT";
      }

      //EmailAlertPm
      if ((self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") && val.includes("USER"))
      {
        self.ShowEmailAlertPM = true;
      }
      else
      {
        self.ShowEmailAlertPM = false;
      }
    },
    onCucProfileTypeCodeChange: function() {
      let self = this;
      //Reset value
      $("input:radio").prop("checked", false);
      self.ShowAgentMappingSelect2 = false;
      $("#cucAgenCodeMapping")
        .val("")
        .trigger("change");

      this.cucAgenCodeMapping = [];

      self.ShowPhaseSelect2 = false;
      $("#cucPhases")
        .val("")
        .trigger("change");
      self.cucPhases = [];

      // Reset Budget Plan fields
      self.ShowBudgetOrgSelect2 = false;
      self.cucBudgetOrgIds = [];

      $("#cucCompanyCode")
        .val("")
        .trigger("change");

      if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_BR") {
        //Set Checked Def.
        $("#brJOB_RETRIEVE_ITEM").prop("checked", true);
      } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT") {
        //Set Checked Def.
        $("#aJOB_RETRIEVE_ITEM").prop("checked", true);
      } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT") {
        //Set Checked Def.
        $("#sJOB_RETRIEVE_ITEM").prop("checked", true);
      } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") {
        $("#USER_DASHBOARD").prop("checked", true);
      }
    },
    // onChnageAgenCodeMapping: function(e) {
    //   var self = this;
    //   self.ShowAgentMappingSelect2 = false;
    //   self.cucAgenCodeMapping = [];

    //   // if(self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_PM" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_BEER_CLAIM" ||
    //   // self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" ||
    //   // self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_5S" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING"){
    //   //   return true;
    //   // }else{
    //   //   return false;
    //   // }
    // },
    onShowCompanySelect2: function(e) {
      var self = this;
      // CR-StockCoverDays: SCVD ผูกคลังเฉพาะ "ผู้ใช้งาน" (SCVD_VIEWER) เท่านั้น
      // แอดมิน (SCVD_ADMIN) + ทีมสร้าง/แก้ไข (SCVD_TEAM_EDIT) เห็นทุกคลัง → ซ่อนช่อง "บริษัท" + ไม่ required
      // (ซ่อนแล้ว jQuery validate ข้าม required อัตโนมัติผ่าน settings.ignore = ":hidden")
      if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SCVD") {
        return self.scvdRole == "SCVD_VIEWER";
      }
      if (
        self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_BR" ||
        self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT" ||
        self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT"
      ) {
        return true;
      } else {
        return false;
      }
    },
    SelectAllAgent:function(e){
      var self = this;
      var checkAllAgent = $("input[name=cucIsAllAgent]").prop("checked");
      if(checkAllAgent){
          self.cucAgenCodeMappingOptions.forEach((x) => {
                    self.cucAgenCodeMapping.push(x.id);
                  });
        }
        else{
          self.cucAgenCodeMapping = []; 
          $("#cucAgenCodeMapping")
          .val("")
          .trigger("change");
        } 
    },
    LoadcucAgenCodeMappingOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchAgentName", {
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.cucAgenCodeMappingOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadcucPhaseOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterPhase/Select2Phase", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.cucPhaseOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    // Budget Plan Methods
    OnBudgetPlanRoleChange: function(e) {
      var self = this;
      var val = e.target.value;

      // ผู้ตรวจสอบ (Reviewer) จะมองเห็นทุก Org ไม่ต้องเลือก
      if (val == "BUDGET_PLAN_REVIEWER") {
        self.ShowBudgetOrgSelect2 = false;
        self.cucBudgetOrgIds = [];
      } else {
        // ผู้ใช้งาน และ ผู้จัดการฝ่าย ต้องเลือก Org
        self.ShowBudgetOrgSelect2 = true;
      }
    },
    LoadcucBudgetOrgOptions: function() {
      var self = this;
      axios
        .get("/Api/CompanyProfile/Select2BudgetOrgs", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.cucBudgetOrgOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    self.LoadcucAgenCodeMappingOptions();
    self.LoadcucPhaseOptions();
    self.LoadcucBudgetOrgOptions();  

    //set validation rules
    $(this.$refs.form).validate({
      rules: {
        cucProfileName: "required",
        cucProfileTypeCode: "required",
        cucCompanyCode: "required",
        cucRoles: {
          required: true,
          minlength: 1,
        },
        cucAgenCodeMapping: "required",
        cucPhases: "required",
      },
      messages: {
        cucProfileName: "กรุณากรอกชื่อโปรไฟล์บริษัท",
        cucProfileTypeCode: "กรุณาเลือกประเภทโปรไฟล์บริษัท",
        cucCompanyCode: "กรุณาเลือกบริษัท",
        cucRoles: "กรุณาเลือกบทบาท",
        cucAgenCodeMapping: "กรุณาเลือกตัวแทนจำหน่าย",
        cucPhases: "กรุณาเลือก Phase",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/CompanyProfile/CompanyProfileCreate.vue